import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const defaultWeightSource = ["settings", "onboarding", "fallback"] as const;
export type DefaultWeightSource = (typeof defaultWeightSource)[number];

export const getTeamDefaultWeight = unaryRpc({
  name: "getTeamDefaultWeight" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    weightOunces: z.number(),
    source: z.enum(defaultWeightSource),
  }),
});
